export default __webpack_public_path__ + "static/media/Pilgrim's Wrist-straps of the Eldritch.619ef46e.jpg";